import { isValidElement, useRef, useState } from "react";

import { Dialog, Transition } from "@headlessui/react";

const Popup = ({
  components,
  children,
  className,
  closeButton,
  onClose,
  onOpen,
  disableAccessibility,
  ...props
}) => {
  const CloseButton = closeButton;
  const [isOpen, setIsOpen] = useState(false);
  const openButtonRef = useRef(null);

  function closeModal(event) {
    // Chỉ cho phép tắt popup khi popup đang mở
    if (isOpen) {
      setIsOpen(false);
      if (onClose) onClose(event);
    }
  }

  function openModal(event) {
    // Chỉ cho phép bật popup khi popup chưa được mở
    if (!isOpen) {
      setIsOpen(true);
      if (onOpen) onOpen(event);
    }
  }

  return (
    <>
      <button
        // Fix: "...there are no focusable elements"
        ref={openButtonRef}
        type="button"
        onClick={openModal}
        className={`focus:right-0 focus:outline-none ${className}`}
        {...props}
      >
        {children}
      </button>
      <Transition appear show={isOpen} as={"div"}>
        <Dialog
          as="div"
          className="fixed inset-0 overflow-y-auto"
          // Disable mouse interaction (outside click) & keyboard interaction
          onClose={disableAccessibility ? () => {} : closeModal}
          style={{ zIndex: 51 }}
          // Fix there are no focusable elements
          initialFocus={openButtonRef}
        >
          <div className="flex min-h-screen items-center justify-center px-4">
            <Transition.Child
              as={"div"}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0 bg-slate-900 bg-opacity-70" />
            </Transition.Child>

            {/* This element is to trick the browser into centering the modal contents. */}
            <span
              className="inline-block h-screen align-middle"
              aria-hidden="true"
            >
              &#8203;
            </span>
            <Transition.Child
              as={"div"}
              className="relative z-50"
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              {components}
              {CloseButton && isValidElement(<CloseButton />) && (
                <CloseButton onClick={closeModal} />
              )}
            </Transition.Child>
          </div>
        </Dialog>
      </Transition>
    </>
  );
};

export default Popup;
